export const encodeBase64 = (string: string) => window.btoa(string);
export const decodeBase64 = (string?: string) =>
  string ? window.atob(string) : "";
